var React = require('react');

function Person (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m17 7c0 2.76142-2.2386 5-5 5-2.76142 0-5-2.23858-5-5s2.23858-5 5-5c2.7614 0 5 2.23858 5 5zm-1.2 0c0 2.09868-1.7013 3.8-3.8 3.8-2.09868 0-3.8-1.70132-3.8-3.8s1.70132-3.8 3.8-3.8c2.0987 0 3.8 1.70132 3.8 3.8zm-12.8 14c0-4.4183 3.58172-8 8-8h2c4.4183 0 8 3.5817 8 8 0 0-3 1-9 1s-9-1-9-1zm7.9958-6.8c-3.33964 0-6.18497 2.4251-6.71412 5.7226l-.03168.1974s2.75.68 7.75.68 7.75-.68 7.75-.68l-.0427-.2526c-.5527-3.2721-3.3865-5.6674-6.705-5.6674z","fillRule":"evenodd"}));
}

Person.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Person;

Person.default = Person;
